module.exports = __webpack_public_path__ + "img/alipay_20200315135751.9de37eee.png";